import {app} from "core/util";

import {NAME} from './constants';

const getModel = app.createGetModel(NAME);
export const getTypes = (state) => getModel(state);
export const getType = (state, type) => getModel(state).getIn([type, 'data']);
export const getForceDeleteConfirmationId = (state, type) => getModel(state).getIn([type, 'forceDeleteConfirmationId']);
